import React from "react";
import { tt } from "../../utils/i18n/i18n";
import type KC_Colors from "../../designsystem/KC_Colors";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";

interface KC_NoDataI {
  color?: KC_Colors;
  text?: string;
}

const KC_NoData = ({ text, color }: KC_NoDataI) => (
  <KC_UIText text={text || tt("no_data")} weight="reg" />
);

export default KC_NoData;
